import { Component } from '@angular/core';

@Component({
  selector: 'app-under-construction',
  standalone: false,
  
  templateUrl: './under-construction.component.html',
  styleUrl: './under-construction.component.scss'
})
export class UnderConstructionComponent {

}
